import { IApiBenefitResult } from "../../interfaces/api/group/results/IApiBenefitResult";
import IApiDiscount from "../../interfaces/api/group/results/IApiDiscount";
import IBenefitDiscount from "../../../common/interfaces/IBenefitDiscount";
import { IBenefitResult } from "../../../common/interfaces/IBenefitResult";
import EnumMapper from "./EnumMapper";

export const mapBenefitDiscount = (discount: IApiDiscount): IBenefitDiscount => {
    return {
        type: discount.type,
        value: discount.value,
        percentage: discount.percentage
    };
};

const parseRemoteToLocal = (benefit: IApiBenefitResult): IBenefitResult => {
    return {
        benefitType: EnumMapper.BenefitType.remoteToLocal(benefit.benefitType),

        discountedPremium: benefit.discountedPremium,
        discounts: benefit.discounts.map(mapBenefitDiscount),
        excess: benefit.excess,

        personId: benefit.personID,
        premium: benefit.premium,
        caseId: benefit.caseID,
        coverAmount: benefit.coverAmount,
        productId: benefit.quoteProductID
    };
};

export default {
    remoteToLocal: parseRemoteToLocal
};
